import { EventEmitter, Injectable, Injector } from '@angular/core';
import { AppInsightsService } from './appInsights.service';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import * as StackTrace from 'stacktrace-js';
import { CustomError } from '../model/Errors/customErrors';

@Injectable()
export class LoggerService {

  public ErrorEvent$: EventEmitter<string>;

  public constructor(private injector: Injector, private appInsights: AppInsightsService) {
    this.ErrorEvent$ = new EventEmitter<string>();
  }

  public logEvent(name: string, message: string) {
    console.log(name + ":" + message);
    let logInfo = { "Message": message };
    this.appInsights.logEvent(name, logInfo);
  }

  public notifyUserAboutException(error: any, message: string): boolean {

    let shouldNotify: boolean = !message.includes("Cannot read properties of null (reading 'calander') /plan setTimeout(function"); //daypilot issue

    let innerError = error.rejection;

    // interal custom error should not be notified to client.
    if (innerError !== undefined && innerError instanceof CustomError) {
      shouldNotify = false;
    }

    return shouldNotify
  }

  public logError(error, msg: string = "") {
    let stackTrace: string = "";
    const location = this.injector.get(LocationStrategy);

    const message = msg + " " + error.message ? error.message : error.toString();
    const url = location instanceof PathLocationStrategy ? location.path() : '';

    // get the stack trace, lets grab the last 10 stacks only
    StackTrace.fromError(error)
      .then(stackframes => {
        if (stackframes !== undefined) {
          stackTrace = stackframes
            .splice(0, 20)
            .map(function (sf) {
              return sf.toString();
            }).join('\n');
        }
        console.error("[BKS Error] Exception: ", message, url, stackTrace);
        this.appInsights.logException(error, stackTrace);
        if (this.notifyUserAboutException(error, message)) {
          this.ErrorEvent$.emit(message);
        } else {
          console.log("[BKS Info] Exception not emited to user, whitelisted.");
        }

      }).catch(_ => console.log("Unable to parse error"));

  }



}
